import { baseMarkPattern } from './__base'
export const underline = function underline (text) {
  return baseMarkPattern(text, '{+}')
}
